import React, { useEffect, useState } from 'react';
import './support.css';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
const StatusCodes = { "LOADING": "LOADING", "INITIAL": "INITIAL", "FAILED": "FAILED", "SUCCESS": "SUCCESS", "EMPTY": "EMPTY" }
const ProjectDetailss = () => {
  const location = useLocation();

  // Extract and parse the query parameters
  const searchParams = new URLSearchParams(location.search);
  const prjId = searchParams.get("prjid");
  const [projectdetais, setProjectDetais] = useState({})
  const [status, setStatus] = useState(StatusCodes.LOADING)

  useEffect(() => {
    axios.post("https://gantasoft.com//gantasoft/getprojectsbyid.php",
      { "main_id": "8989877hhftgh67", "prj_id": prjId }).then(
        res => {
          if (typeof res.data === 'object' && Object.keys(res.data).length > 0) {
            debugger
            setProjectDetais(res.data)
            setStatus(StatusCodes.SUCCESS)
          } else {
            setStatus(StatusCodes.EMPTY)
          }
        }
      ).catch(e => {
        console.log(e)
        setStatus(StatusCodes.FAILED)
      })
  }
    , [])


  const getProjectDetailsUi = () => {

    switch (status) {
      case StatusCodes.SUCCESS:
        return (<div className="row gy-4">


          {/* Content Section */}
          <div
            className="col-lg-6 content"

          >
            <h3>{projectdetais.p_title}</h3>
            {/* <h5>Welcome to Gantasoft - A Top Web Development Company in India</h5>
    <p>
      We are a trusted and fully registered company in India, offering top-notch web development and design services. Specializing in creating multi-functional web portals, we ensure that every website we develop is visually appealing and optimized for delivering ROI-driven outcomes. Our professional approach guarantees innovative solutions tailored to meet our clients' business needs and goals.
    </p> */}
            {/* <ul>
              {projectdetais.p_content.map(eachHeader => (
                <li>
                  
                  <div>
                    <h5>{eachHeader.header}</h5>
                    <p>
                      {eachHeader.content}
                    </p>
                  </div>
                </li>
              ))}

            </ul> */}
            <p>{projectdetais.p_content}</p>
          </div>
          {/* Image Section */}
          <div
            className="col-lg-6 position-relative order-lg-first"

          >
            <img
              src={projectdetais.p_image}
              className="img-fluid image-ratio"
              alt="project"
            />

          </div>
        </div>)
      case StatusCodes.FAILED:
        return (<div className="row gy-4">
          <h5> Failed getting resourses..........</h5>
        </div>)
        default :
        <div className="row gy-4">
        <h5> Loading..........</h5>
      </div>
    }
  }
  return (

    <section id="home" className="hero home section ">
      <div className="container">
        {getProjectDetailsUi()
        }
      </div>
    </section>
  );
};

export default ProjectDetailss;
